import { render, staticRenderFns } from "./ModalReviewCreate.vue?vue&type=template&id=c2c96980&scoped=true"
import script from "./ModalReviewCreate.vue?vue&type=script&lang=js"
export * from "./ModalReviewCreate.vue?vue&type=script&lang=js"
import style0 from "./ModalReviewCreate.vue?vue&type=style&index=0&id=c2c96980&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c96980",
  null
  
)

export default component.exports